// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    updateQRConf as updateQRConfAPI,
    generateQR as generateQRAPI
} from '../../helpers/';

import { QRConfApiResponseError, QRConfApiResponseSuccess } from './actions';
import { QRConfActionTypes } from './constants';

function* updateQRConf({ payload: QRConf }) {
    try {
        const response = yield call(updateQRConfAPI, { ...QRConf })
        const QRConfItem = response.data.data
        yield put(QRConfApiResponseSuccess(QRConfActionTypes.UPDATE_QR_CONF, QRConfItem))
    } catch (error) {
        yield put(QRConfApiResponseError(QRConfActionTypes.UPDATE_QR_CONF, error))
    }
}

function* generateQR({ payload: params }) {
    try {
        const response = yield call(generateQRAPI, { ...params })
        const QRCode = response.data.data
        yield put(QRConfApiResponseSuccess(QRConfActionTypes.GENERATE_QR, QRCode))
    } catch (error) {
        yield put(QRConfApiResponseError(QRConfActionTypes.GENERATE_QR, error))
    }
}

export function* watchUpdateQRConf(): any {
    yield takeEvery(QRConfActionTypes.UPDATE_QR_CONF, updateQRConf)
}

export function* watchGenerateQR(): any {
    yield takeEvery(QRConfActionTypes.GENERATE_QR, generateQR)
}

function* QRConfSaga(): any {
    yield all([
        fork(watchUpdateQRConf),
        fork(watchGenerateQR),
    ]);
}

export default QRConfSaga;
